// Menu - only keeping the ones that are actually used
import { ReactComponent as MenuLocation } from "../menu_icon/location.svg";
import { ReactComponent as MenuRoster } from "../menu_icon/roster.svg";
import { ReactComponent as MenuLeave } from "../menu_icon/leave.svg";
import { ReactComponent as MenuCompany } from "../menu_icon/company.svg";
import { ReactComponent as MenuUsers } from "../menu_icon/users.svg";

import { ReactComponent as IconPin } from "../Images/icon-pin.svg";
import { ReactComponent as IconPinned } from "../Images/icon-pinned.svg";
import { ReactComponent as LogoIcon } from "../Images/logo-icon.svg";
import IconPlane from "../Images/plane.png";
import { ReactComponent as IconUser } from "../Images/user.svg";
import { ReactComponent as IconPound } from "../Images/pound.svg";
import { ReactComponent as IconBed } from "../Images/bed.svg";
import { ReactComponent as IconResidency } from "../Images/residency.svg";
import { ReactComponent as IconCalendar } from "../Images/calendar.svg";
import { ReactComponent as IconStatStat } from "../Images/staff-stat.svg";
import { ReactComponent as IconCalendarStat } from "../Images/calendar-stat.svg";

import { ReactComponent as IconLink } from "../Icons/link.svg";
import { ReactComponent as IconPaidZero } from "../Icons/zero.svg";
import { ReactComponent as IconSick } from "../Icons/sick.svg";
import { ReactComponent as IconStatus } from "./status.svg";

import { ReactComponent as IconLock } from "./lock.svg";
import { ReactComponent as IconUnlock } from "./unlock.svg";

import { ReactComponent as IconFlexible } from "./flexible.svg";
import { ReactComponent as IconPasswordSet } from "./password-set.svg";
import { ReactComponent as IconAutoClock } from "./autoclock.svg";

import IconFeedWork from "./kudos/work.png";
import IconFeedBirthday from "./kudos/birthday.png";
import IconFeedStar from "./kudos/star.png";
import IconFeedThank from "./kudos/thankyou.png";
import IconFeedCongra from "./kudos/congratulations.png";
import KudosFeedBanner from "./kudos/banner.png";

import { ReactComponent as IconSavedFilter } from "./saved-filter.svg";

import { ReactComponent as IconSurveyScratch } from "./survey/survey-scratch.svg";
import { ReactComponent as IconSurveyTemplate } from "./survey/survey-template.svg";
import { ReactComponent as IconSurveyStaff } from "./survey/survey-staff.svg";
import { ReactComponent as IconSurveyCustomer } from "./survey/survey-customer.svg";

import { ReactComponent as IconAcknowledgementPending } from "./shift/acknowledgement-pending.svg";
import { ReactComponent as IconAcknowledged } from "./shift/acknowledgement-done.svg";

import { ReactComponent as IconVisitorEnter } from "./visitor-enter.svg";
import { ReactComponent as IconVisitorExit } from "./visitor-leave.svg";
import { ReactComponent as IconVisitorResident } from "./visitor-resident.svg";
import { ReactComponent as IconVisitorWork } from "./visitor-work.svg";

import { ReactComponent as IconFeedPin } from "./icon-pin.svg";
import { ReactComponent as IconFeedUnpin } from "./icon-unpin.svg";

export default {
  MenuLocation,
  IconStatus,
  IconPin,
  IconPinned,
  LogoIcon,
  IconPlane,
  IconUser,
  IconPound,
  IconBed,
  IconResidency,
  IconCalendar,
  IconLink,
  MenuRoster,
  MenuLeave,
  MenuCompany,
  MenuUsers,
  IconStatStat,
  IconCalendarStat,
  IconLock,
  IconUnlock,
  IconFlexible,
  IconPaidZero,
  IconSick,
  IconPasswordSet,
  IconAutoClock,

  // Kudos
  IconFeedWork,
  IconFeedBirthday,
  IconFeedStar,
  IconFeedThank,
  IconFeedCongra,
  KudosFeedBanner,

  // My Filters
  IconSavedFilter,

  // Shift Acknowledgement
  IconAcknowledged,
  IconAcknowledgementPending,

  // Survey
  IconSurveyScratch,
  IconSurveyTemplate,
  IconSurveyStaff,
  IconSurveyCustomer,

  // Visitor
  IconVisitorEnter,
  IconVisitorExit,
  IconVisitorResident,
  IconVisitorWork,

  // Pin
  IconFeedPin,
  IconFeedUnpin,
};
